// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__18EuH","inputWrap":"CustomTip_inputWrap__3nD9r"};